import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import React, { Component } from "react";
import {
  BrowserRouter,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import styles from "./LoginStyle";
import AppTheme from "../AppTheme";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";

import Paper from "@material-ui/core/Paper";
import Auth from "../modules/auth";


 class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formInputData: {
        accessCode: ""
      },
      redirectToReferrer: false,
      errors: {
        accessCode: {
          hasError: false,
          isPristine: true,
          message: ""
        }
      }
    };
    this.login = this.login.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.keyPress = this.keyPress.bind(this);
  }
  async login() {
    const response = await Auth.authenticate(this.state.formInputData.accessCode,'BEDS')
    
    if (response) {
      this.setState(() => ({
        redirectToReferrer: true
      }));
    } else {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          accessCode: {
            hasError:true,
            isPristine: true,
            message:"Cod acces incorect!"
          }
        }
      }));
    }
  }

  handleChange(event) {
    const targetName = event.target.name;
    const value = event.target.value;
    this.setState(prevState => ({
      formInputData: {
        ...prevState.formInputData,
        [targetName]: value
      }
    }));
  }

  handleFormFieldBlur = targetName => {
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [targetName]: {
          ...prevState.errors[targetName],
          isPristine: false
        }
      }
    }));
  };
  keyPress(e){
    if(e.keyCode == 13){
      this.login()
    }
 }


  render() {
    const { from } = this.props.location.state || { from: { pathname: "/" } };

    const { errors } = this.state;
    const { classes } = this.props;

    if (Auth.isUserAuthenticated()||this.state.redirectToReferrer) return <Redirect to={from} />
    else {

    return (
      <MuiThemeProvider theme={AppTheme}>
        <div className={classes.bedsDashboard}>
          <AppBar className={classes.secondaryAppBar} position="static">
            <Toolbar className={classes.secondaryToolBar}>
              <div className={classes.secondaryToolBarText}>
                <Typography
                  variant="h2"
                  className={classes.secondaryAppBarTitle}
                >
                  <i className="medical-icon-hospital appToolbar-menu " />{" "}
                  Spital MS Curie București
                </Typography>
                <Typography
                  variant="h6"
                  className={classes.secondaryAppBarSubTitle}
                >
                  <i className="medical-icon-i-administration appToolbar-menu " />{" "}
                  Secția Terapie Intensivă Nou-Născuți
                </Typography>
              </div>
            </Toolbar>
          </AppBar>
          <div
            style={{
              marginTop: "200px",
              display: "flex",
              flex: "1",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <Paper
              style={{
                width: "300px",
                height: "200px",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <FormControl error={errors.accessCode.hasError}>
                <InputLabel htmlFor="firstName">Cod de access </InputLabel>
                <Input
                  inputProps={{
                    name: "accessCode",
                    id: "accessCode"
                  }}
                  type="password"
                  required
                  value={this.state.formInputData.accessCode}
                  onChange={this.handleChange}
                  onKeyDown={this.keyPress}
                  onBlur={() => this.handleFormFieldBlur("accessCode")}
                />
                <FormHelperText>{errors.accessCode.message}</FormHelperText>
              </FormControl>
              <Button
                className={classes.sendButton}
                variant="contained"
                color="primary"
                onClick={this.login}
              >
                Trimite
              </Button>
            </Paper>
          </div>
        </div>
      </MuiThemeProvider>
    );}
  }
}

export default withStyles(styles)(Login);
